import { render, staticRenderFns } from "./ExpedienteHorarios.vue?vue&type=template&id=4f5560e1"
import script from "./ExpedienteHorarios.vue?vue&type=script&lang=js"
export * from "./ExpedienteHorarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports